import { ApplicationConfig, provideZonelessChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { SSOService } from './services/sso.service';
import { LoadingService } from './core/services/loading.service';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';

const KanseiPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#f3f5ff',
      100: '#e7eaf8',
      200: '#b6c1d7',
      300: '#8598b5',
      400: '#3d5b83',
      500: '#0c3257',
      600: '#003160',
      700: '#040e18',
      800: '#020c12',
      900: '#01060a',
      950: '#010305'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(
      withFetch(),
      withInterceptors([LoadingInterceptor, authInterceptor])
    ),
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
    MessageService,
    SSOService,
    LoadingService,
    provideRouter(routes), 
    provideClientHydration(),
    importProvidersFrom(BrowserAnimationsModule),
    providePrimeNG({
      theme: {
        preset: KanseiPreset,
        options: {
          darkModeSelector: false
        }
      },
      ripple: false, // Disable ripple effect for better performance
      zIndex: {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100
      }
    })
  ]
};
